import { upload } from '@client/components/ajax';
import { influencerMuxVideoUpload } from '../muxVideoUpload';
import React from 'react';

export type UploadConfig = {
  onProgress?: (percent: number) => void;
  s3SkipCompression?: boolean;
};

export const useInfluencerAssetsUploader = (influencerId: number) => {
  const [uploadCount, setUploadCount] = React.useState(0);

  const s3ImageUpload = async (
    file: File,
    config?: {
      onProgress?: (percent: number) => void;
      skipCompression?: boolean;
    },
  ) => {
    const { cdn01, image }: any = await upload(file, influencerId, {
      onProgress: (x) => config?.onProgress && config.onProgress(x * 100),
    });
    return cdn01 + image;
  };

  const muxVideoUpload = async (
    file: File,
    config?: UploadConfig,
  ): Promise<string> => {
    const m = await influencerMuxVideoUpload(influencerId, file, {
      onProgress: config?.onProgress,
    });

    const highestQualityAvailable =
      m.downloadLink?.high ?? m.downloadLink?.medium ?? m.downloadLink?.low;

    return highestQualityAvailable?.link as string;
  };

  const universalUpload = async (file: File, config: UploadConfig = {}) => {
    const s3Config = {
      onProgress: config.onProgress,
      skipCompression: config.s3SkipCompression,
    };

    setUploadCount((x) => x + 1);

    if (file.type && file.type.startsWith('video/')) {
      return await muxVideoUpload(file, config).finally(() => {
        setUploadCount((x) => x - 1);
      });
    } else {
      return await s3ImageUpload(file, s3Config).finally(() => {
        setUploadCount((x) => x - 1);
      });
    }
  };

  return {
    universalUpload,
    isUploading: uploadCount > 0,
  };
};
